/**
 * The Cooked Sushi product page — responsive mobile sticky add-to-cart bar
 */
(function () {
  const section = document.querySelector('.nihooya-product-section');
  if (!section) return;

  const mobileBar = section.querySelector('[data-nihooya-mobile-bar]');
  const priceEl = section.querySelector('.nihooya-product__price-current');
  const submitBtn = section.querySelector('.product-form__submit');
  const productForm = section.querySelector('form[data-type="add-to-cart-form"]');
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  if (!mobileBar || !submitBtn || !productForm) return;

  const barPrice = mobileBar.querySelector('[data-nihooya-mobile-price]');
  const barBtn = mobileBar.querySelector('[data-nihooya-mobile-submit]');

  function isMobileLayout() {
    return mobileQuery.matches;
  }

  function syncMobileBar() {
    if (barPrice && priceEl) {
      barPrice.textContent = priceEl.textContent.trim();
    }

    if (barBtn) {
      const isDisabled = submitBtn.hasAttribute('disabled') || submitBtn.getAttribute('aria-disabled') === 'true';
      barBtn.disabled = isDisabled;
      const label = submitBtn.querySelector('[data-add-to-cart-text]') || submitBtn.querySelector('.nihooya-product__submit-text');
      if (label) barBtn.textContent = label.textContent.trim();
    }
  }

  function setBarVisible(visible) {
    if (!isMobileLayout()) {
      mobileBar.classList.remove('is-visible');
      mobileBar.setAttribute('aria-hidden', 'true');
      mobileBar.setAttribute('inert', '');
      return;
    }

    mobileBar.classList.toggle('is-visible', visible);
    mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) {
      mobileBar.removeAttribute('inert');
    } else {
      mobileBar.setAttribute('inert', '');
    }
  }

  function initStickyBarObserver() {
    if (!('IntersectionObserver' in window)) {
      window.addEventListener('scroll', fallbackToggle, { passive: true });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setBarVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );

    observer.observe(submitBtn);

    mobileQuery.addEventListener('change', () => {
      if (!isMobileLayout()) setBarVisible(false);
    });
  }

  function fallbackToggle() {
    if (!isMobileLayout()) {
      setBarVisible(false);
      return;
    }

    const rect = submitBtn.getBoundingClientRect();
    setBarVisible(rect.bottom < 0 || rect.top > window.innerHeight);
  }

  barBtn?.addEventListener('click', () => {
    if (submitBtn.disabled) return;
    submitBtn.click();
  });

  const observer = new MutationObserver(syncMobileBar);
  observer.observe(submitBtn, { attributes: true, childList: true, subtree: true });

  const priceContainer = section.querySelector('[id^="price-"]');
  if (priceContainer) {
    observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  window.addEventListener('resize', () => {
    if (!isMobileLayout()) setBarVisible(false);
  });

  function pulseSubmitButton() {
    submitBtn.classList.remove('is-pulse');
    void submitBtn.offsetWidth;
    submitBtn.classList.add('is-pulse');
    window.setTimeout(() => submitBtn.classList.remove('is-pulse'), 600);
  }

  section.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.name !== 'id' && !target.closest('variant-radios, variant-selects')) return;
    pulseSubmitButton();
    syncMobileBar();
  });

  setBarVisible(false);
  syncMobileBar();
  initStickyBarObserver();
})();